import { getRootContainerProps } from "@client/content/lib/helper";
import { type RootContainerProps } from "@client/content/types";
import Icon from "@client/controls/Icon/component";
import { makePopup } from "@client/controls/Popup/container";
import { BackgroundContainer } from "@client/controls/Style/Background/container";
import withIsVisibleHOC, { type WithIsVisibleHOCProps } from "@client/hocs/withIsVisible";
import { cultureCodeSelector, TargetSelector } from "@client/selectors";
import { type EnhanceWidget, IconType, type WithClassName } from "@client/types";
import { type WithChildren } from "@client/types/WithChildren";
import Flag from "@common/controls/Flag/component";
import classNames from "classnames";
import React from "react";
import { getWidgetDataAttributes } from "../lib";
import CartItem from "./CartItem/container";
import Form from "./Form/container";
import { type FloatingMenuElement } from "./selectors";

import { useSelector } from "react-redux";
import "./style.less";

export type MapProps = WithIsVisibleHOCProps &
  ContentMapProps & {
    enhance?: EnhanceWidget;
  };

type ContentMapProps = RootContainerProps &
  Partial<WithChildren> &
  Partial<WithClassName> & {
    cartItemCount: number;
    elements: FloatingMenuElement[];
    innerStyle?: React.CSSProperties;
    isEditMode: boolean;
    outerStyle?: React.CSSProperties;
  };
type ContentActionProps = {
  goToCart: () => void;
  onDoubleClick?: () => void;
};
const Popup = makePopup(TargetSelector.Layout, "floatingMenu.popup");
const Content = React.forwardRef((props: ContentActionProps & ContentMapProps, ref: React.RefObject<any>) => {
  const cultureCode = useSelector(cultureCodeSelector);
  const [isPopupVisible, setIsPopupVisible] = React.useState(false);

  return (
    <div
      ref={ref}
      className={classNames("content", props.className)}
      style={props.innerStyle}
      onDoubleClick={props.onDoubleClick}
    >
      <BackgroundContainer prefix="floatingMenu" containerSelector="#wsc_floating_menu_wrapper .content" />

      {props.elements.includes("language") && (
        <div className="item" onClick={props.isEditMode ? undefined : () => setIsPopupVisible(true)}>
          <Flag cultureCode={cultureCode} size={16} />
        </div>
      )}
      {props.elements.includes("currency") && (
        <div className="item" onClick={props.isEditMode ? undefined : () => setIsPopupVisible(true)}>
          <Icon iconClassName={IconType.DollarSign} />
        </div>
      )}
      {props.elements.includes("cart") && <CartItem className="item" />}

      {/* id and source shouldn't not be required. TODO: fix makePopup */}
      <Popup id="floatingMenu" source="content" isVisible={isPopupVisible} onClose={() => setIsPopupVisible(false)}>
        <Form {...getRootContainerProps(props)} />
      </Popup>

      {props.children}
    </div>
  );
});

export type ActionProps = ContentActionProps;
export default withIsVisibleHOC(({ isVisible, enhance, ...props }: ActionProps & MapProps) => {
  const EnhancedContainer = React.useMemo(() => (enhance ? enhance(Content) : null), [enhance]);

  return (
    <div style={props.outerStyle} id="wsc_floating_menu_wrapper" className={props.className}>
      <div {...getWidgetDataAttributes("floatingMenu", "Floating menu")} className="menu" data-title="Menu">
        {EnhancedContainer ? <EnhancedContainer title="Menu" {...props} /> : <Content {...props} />}
      </div>
    </div>
  );
});
